import { withStyles } from '@material-ui/core';

import Tooltip from './component';
import styles from './styles';

export default withStyles(styles)(Tooltip);
